module.exports = __webpack_public_path__ + "static/media/meulocker_logo.7f0818fd.png";